export class Settings {
  _id: string;
  dutyAmount: number;
  nosepadsInstallAmount: number;
  drillMountAmount: number;

  constructor(obj?: Partial<Settings>) {
    this._id = obj?._id ?? 'system';
    this.dutyAmount = obj?.dutyAmount ?? 50;
    this.nosepadsInstallAmount = obj?.nosepadsInstallAmount ?? 0;
    this.drillMountAmount = obj?.drillMountAmount ?? 0;
  }
}
